<app-loading-spinner *ngIf="showSpinner"></app-loading-spinner>
<div *ngIf="!showSpinner">
  <app-menu></app-menu>
  <mat-card>
    <mat-card-content>
      <h3 align="center"> Quero participar como </h3>
      <div class="escolher-perfil">
        <button mat-raised-button class="perfil-button" (click)="mudarPerfil(3)">Avaliador</button>
        <button mat-raised-button class="perfil-button" (click)="mudarPerfil(2)">Mentor</button>
        <button mat-raised-button class="perfil-button" (click)="mudarPerfil(1)">Participante</button>
      </div>
    </mat-card-content>
  </mat-card>
</div>
